import React, { useEffect, useRef } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import toast from "react-hot-toast";
import { Form, Input, Select } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthContext } from "../../../context/AuthContext";
import { LoadingOutlined } from "@ant-design/icons";
import {
  createBankDetails,
  updateBankDetails,
} from "../../../utils/api/offset-details";
// import Select from "antd";

const inputClass = "border-0 border-b-2 rounded-none";
const { Option } = Select;

const CreateDialogBox = ({ open, onOk, onCancel, bankData }) => {
  const [form] = Form.useForm();
  const { setAuthUser } = useAuthContext();
  const queryClient = useQueryClient();
  const parentRef = useRef(null);

  useEffect(() => {
    if (bankData) {
      form.setFieldsValue({
        bank_name: bankData.bank_name,
        account_owner_name: bankData.account_owner_name,
        bank_address: bankData.bank_address,
        account_no: bankData.account_no,
        account_type: bankData.account_type,
        IFSC_code: bankData.IFSC_code,
        swift_code: bankData.swift_code,
        MICR_code: bankData.MICR_code,
      });
    }
  }, [bankData, form]);

  useEffect(() => {
    if (parentRef && parentRef.current) {
      parentRef.current.scrollTop = 0;
    }
  }, [open]);
  const { mutate: editHandler, isLoading: editLoader } = useMutation({
    mutationFn: async (data) => {
      try {
        const response = await updateBankDetails(
          bankData._id,
          data,
          setAuthUser
        );      
        return response;
      } catch (error) {
        console.error("Mutation Error:", error);
        throw error;
      }
    },
    onSuccess: (data) => {
      form.resetFields();
      toast.success("Bank Details updated");
      queryClient.invalidateQueries(["bankDetails"]);
      onOk();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: async (data) => {
      try {
        return await createBankDetails(data, setAuthUser);
      } catch (error) {
        throw error;
      }
    },
    onSuccess: (data) => {
      form.resetFields();
      toast.success("Bank Details created");
      queryClient.invalidateQueries(["bankDetails"]);
      onOk();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const onFinish = (data) => {
    if (bankData) {
      editHandler(data);
    } else {
      mutate(data);
    }
  };

  return (
    <DiaglogBox
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      width={617}
      height={600}
    >
      <div
        className="px-6 max-h-96 overflow-auto no-scrollbar py-4"
        ref={parentRef}
      >
        <h3 className="text-[1.75rem] pb-2 font-bold text-black">
          {bankData ? "Edit Bank Account" : "Add Bank Account"}
        </h3>
        <Form
          form={form}
          onFinish={onFinish}
          noValidate
          className="offset-form font-spaceGrotesk"
        >
          <div className="flex gap-x-8">
            <Form.Item
              label="Bank Name"
              className="text-xl font-normal w-1/2"
              name="bank_name"
              rules={[
                {
                  required: true,
                  message: "Please enter Bank Name",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input className={inputClass} />
            </Form.Item>
            <Form.Item
              label="Account Owner Name"
              className="font-normal w-1/2"
              name="account_owner_name"
              rules={[
                {
                  required: true,
                  message: "Please enter full name",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input className={inputClass} />
            </Form.Item>
          </div>
          <hr />
          <Form.Item
            label="Bank Location"
            className="font-normal"
            name="bank_address"
            rules={[
              {
                required: true,
                message: "Please enter full address",
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input className={inputClass} />
          </Form.Item>
          <hr />
          <div className="flex gap-x-8">
            <Form.Item
              label="Account No."
              className="font-normal w-1/2"
              name="account_no"
              rules={[
                {
                  required: true,
                  message: "Please enter account no.",
                },
                {
                  pattern: /^[0-9]*$/,
                  message: "Please enter a valid ACCOUNT NUMBER.",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input className={inputClass} />
            </Form.Item>
            <Form.Item
              label="Account Type"
              className="font-normal w-1/2"
              name="account_type"
              rules={[
                {
                  required: true,
                  message: "Please enter Account Type",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Select className={inputClass}>
                {" "}
                <Option value="Savings Account">Savings Account</Option>{" "}
                <Option value="Current Account">Current Account</Option>{" "}
              </Select>
            </Form.Item>
          </div>
          <hr />
          <div className="flex gap-x-8">
            <Form.Item
              label="IFSC Code"
              className="font-normal w-1/2"
              name="IFSC_code"
              rules={[
                {
                  required: true,
                  message: "Please enter IFSC Code",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input className={inputClass} />
            </Form.Item>
            <Form.Item
              label="Swift Code"
              className="font-normal w-1/2"
              name="swift_code"
              rules={[
                {
                  required: true,
                  message: "Please enter Swift Code",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input className={inputClass} />
            </Form.Item>
          </div>
          <hr />
          <Form.Item
            label="MICR Code"
            className="font-normal"
            name="MICR_code"
            rules={[
              {
                required: true,
                message: "Please enter MICR Code",
              },
              {
                pattern: /^[0-9]*$/,
                message: "Please enter a valid MICR CODE.",
              },
            ]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input className={inputClass} />
          </Form.Item>

          <div className="flex gap-x-4 mt-4">
            <Button
              className={"w-1/2 py-2 text-white font-bold"}
              color={"blue"}
              varient={"primary"}
              type="submit"
            >
              {isLoading || editLoader ? (
                <LoadingOutlined />
              ) : bankData ? (
                "Save"
              ) : (
                "Submit"
              )}
            </Button>

            <Button
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
              className={
                "w-1/2 py-2 bg-blue-400 font-bold text-blue-800 border-[1px] "
              }
              varient={"primary"}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    </DiaglogBox>
  );
};

export default CreateDialogBox;
